import React from 'react';
import Link from './Link';
import { ReactComponent as ArrowLeft } from 'assets/img/arrow-left.svg';
import CompareCountiesStatsSelector from './CompareCountiesStatsSelector';

export default function CompareCountiesSidePanel({
  children: _children,
  activeCounty,
  backLinkAction,
  items,
  searchQuery,
  searchResults,
  setSearchQuery,
  isSearchResultsLoading,
  updateSelected,
  activeCompareCounty,
}) {
  return (
    <div data-component-name='CompareCountiesSidePanel' className='h-full'>
      <div className='flex flex-col h-full text-blue-600'>
        {backLinkAction && (
          <Link
            action={backLinkAction}
            icon={<ArrowLeft />}
            isIconLeft={true}
            color='text-blue-500/60'
          >
            <span className='text-base -translate-y-px'>back</span>
          </Link>
        )}

        <h2 className='pb-4 mt-4 text-lg font-bold'>Compare counties</h2>

        <div className='h-full overflow-auto pb-7'>
          <div className='h-full pt-2'>
            <CompareCountiesStatsSelector
              activeCounty={activeCounty}
              items={items}
              searchQuery={searchQuery}
              searchResults={searchResults}
              setSearchQuery={setSearchQuery}
              isSearchResultsLoading={isSearchResultsLoading}
              updateSelected={updateSelected}
              activeCompareCounty={activeCompareCounty}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
